import { verrichtingenResponseSchema } from '@ksyos/http';
import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const contract = initContract();

export const verrichtingenContract = contract.router({
    getVerrichtingen: {
        metadata: {
            openApiTags: ['Patient'],
        },
        method: 'GET',
        path: `/api/v2/patient/verrichtingen`,
        query: z.strictObject({
            serviceGroupName: z.string().optional(),
        }),
        responses: {
            200: verrichtingenResponseSchema,
        },
        summary: 'Get the verrichtingen for a patient',
    },
});

export type VerrichtingenContract = typeof verrichtingenContract;
